/*
 * @Descripttion: 
 * @Author: huxianglong
 * @Date: 2023-07-03 10:59:04
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-02-01 15:33:23
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import { getCheckStart } from '@/api/user'
import { isH5 } from '@/utils/util'
const h5 = isH5()
const routes: Array<any> = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/main/index.vue'),
  },
  {
    path: '/',
    redirect: h5 ? '/h5index' : '/guid'
  },
  {
    path: '/h5index',
    name: 'h5',
    component: () => import('@/views/guid/h5Index.vue')
  },
  {
    path: '/guid',
    name: 'guid',
    component: () => import('@/views/guid/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
  },
  {
    path: '/plan',
    name: 'plan',
    component: () => import('@/views/plan/index.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component:() => import('@/views/notfund/index.vue')
  },
  {
    path: '/checksystem/login',
    name: 'checksystemLogin',
    component: () => import('@/views/checksystem/login/index.vue')
  },
  {
    path: '/checksystem/bigPlan',
    name: 'bigPlan',
    component: () => import('@/views/checksystem/bigPlan/index.vue')
  },
  {
    path: '/report/system',
    name: 'reportSystem',
    component: () => import('@/views/report/system/index.vue')
  },
  {
    path: '/report/login',
    name: 'reportLogin',
    component: () => import('@/views/report/login/index.vue')
  },
  {
    path: '/report/test',
    name: 'reportTest',
    component: () => import('@/views/report/system/test.vue')
  },
  {
    path: '/checkscore/login',
    name: 'checkscoreLogin',
    component: () => import('@/views/checkscore/login/index.vue')
  },
  {
    path: '/checkscore/scorelist',
    name: 'scoreLists',
    component: () => import('@/views/checkscore/scorelist/index.vue')
  },
  // {
  //   path: '/pdf',
  //   name: 'pdf',
  //   component: () => import('@/views/report/system/components/report-pic-template.vue')
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})
const whiteLists = ['/report/system', '/report/test' ]

h5 ? whiteLists.push('/h5index') : whiteLists.push(...['/guid', '/report/login', '/checkscore/login', '/checksystem/login'])
const examLists = ['/login', '/home','/plan']
router.beforeEach( async(to, from, next) => {
  const orgData = window.sessionStorage.getItem('orgData')
  const pOrgData = orgData ? JSON.parse(orgData) : null
  if(pOrgData?.id) {
    if(whiteLists.includes(to.path)) {
      next()
    } else if(examLists.includes(to.path)){
      const userInfo = window.sessionStorage.getItem('login_user_info')
      if(pOrgData?.onlineExam) {
        if (!userInfo) {
          to.path === '/login' ? next() : next('/login')
        } else {
          const user = JSON.parse(userInfo)
          if(to.path === '/home') {
            if(user.planId) {
             const res = await getCheckStart(user.planId)
             if(res.code === '0000' && res.data) {
                next()
             } else {
              console.log(`output->`, `当前计划未被点击过...${user.planId}`)
              next({
                name: '404'
              })
             }
            } else {
              console.log(`output->`, `当前未点击任何计划`)
              next({
                name: '404'
              })
            }
          } else {
            next()
          }
        }
      } else {
        h5 ? next('/h5index'): next('/guid')
      }
    } else if(to.path === '/checksystem/bigPlan') {
      checkIdCard('checkReportIdCard', 'checksystemLogin', next)
    } else if(to.path == '/checkscore/scorelist') {
      checkIdCard('checkScoreCard', 'checkscoreLogin', next)
    }else {
      next()
    }
  } else {
    if(to.path === '/guid' || to.path === '/h5index') {
      next()
    } else {
      h5 ? next('/h5index'): next('/guid')
    }
  }
})

const checkIdCard = (cardType:string, redirectName:string, next:any) => {
  const idCard = window.sessionStorage.getItem(`${cardType}`)
      if(idCard) {
         next()
      } else {
         next({
           name: `${redirectName}`
         })
      }
}
export default router
